import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const RoleItemSchema = z.object({
  _id: z.string().or(z.any()),
  name: z.string(),
  createdAt: z.date().or(z.string()).optional(),
  updatedAt: z.date().or(z.string()).optional(),
});

export const rolesContract = c.router({
  getRoles: {
    method: 'GET',
    path: '/admin/roles',
    responses: {
      200: z.object({
        data: z.array(RoleItemSchema),
      }),
    },
  },
});
